import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { CommonStore } from '../stores/commonStore';

@observer
class Disclaimer extends Component {
  render() {
    const { commonStore } = this.props;
    const { disclaimer } = commonStore;
    const showDisclaimer = disclaimer.showBlock;
    if (showDisclaimer) {
      return (
        <div className="section">
          <h4>Disclaimer</h4>
          <hr />
          <div className="text-sm-center">
            <small>
              <div style={{ padding: '10px', textAlign: 'justify' }}>{disclaimer.content}</div>
            </small>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default Disclaimer;

Disclaimer.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore).isRequired
};
